@if (isMessageRecipientsSpinnerShowing$ | async) {
  <div id="loading-container">
    <!--    <mat-progress-spinner mode="indeterminate" class="spinner"></mat-progress-spinner>-->
    <mat-progress-bar mode="indeterminate" class="bar"></mat-progress-bar>
  </div>
} @else {
  @if (currentMessageRecipient$ | async; as messageRecipient) {
    <div
      id="history-container"
      >
      <div id="header">
        <span id="timestamp">
          {{ messageRecipient.message_set.created | date: "medium" }}
        </span>
        <span id="message-count">
          {{ (currentMessageRecipientIndex$ | async) + 1 }} {{ "HISTORY_OF" | translate }}
          {{ messageRecipientCount$ | async }}
        </span>
      </div>
      <div
        class="message-set-wrapper"
      [ngClass]="{
      center:
        messageRecipient.message_set.messages[0].images.length === 0 &&
        messageRecipient.message_set.messages[0].videos.length === 0
    }"
        >
        @if (
          messageRecipient.message_set.messages[0].images.length > 0 ||
          messageRecipient.message_set.messages[0].videos.length > 0
          ) {
          <div
            class="thumbnail-container"
            >
            @if (messageRecipient.message_set.messages[0].images.length > 0) {
              <div
                class="image-thumbnail"
                >
                <img
                  [src]="messageRecipient.message_set.messages[0].images[0].large_url"
                  />
              </div>
            }
            @if (messageRecipient.message_set.messages[0].videos.length > 0) {
              <div
                class="video-thumbnail"
                >
                @if (
                  messageRecipient.message_set.messages[0].videos[0].encodings
                  .length > 0
                  ) {
                  <img
            [src]="
            messageRecipient.message_set.messages[0].videos[0].encodings[0]
              .thumbnails[0].file
          "
                    />
                }
                @if (
                  messageRecipient.message_set.messages[0].videos[0].encodings
                  .length == 0
                  ) {
                  <svg
                    class="icon grid"
                    viewBox="0 0 32 32"
                    >
                    <use xlink:href="#icon-video"></use>
                  </svg>
                }
              </div>
            }
            <div class="key">
              <div class="zoom-icon"></div>
              <span>{{
                messageRecipient.message_set.messages[0].images.length > 0
                ? "zoom"
                : "play"
              }}</span>
            </div>
          </div>
        }
        <div class="message-content">
          <div class="subject">
            @if (
              messageRecipient.message_set.messages[0].images[0] ||
              messageRecipient.message_set.messages[0].videos[0]
              ) {
              <h2
                >
                {{ messageRecipient.message_set.messages[0].subject | truncate: 40 }}
              </h2>
            }
            @if (
              !messageRecipient.message_set.messages[0].images[0] &&
              !messageRecipient.message_set.messages[0].videos[0]
              ) {
              <h2
                >
                {{ messageRecipient.message_set.messages[0].subject | truncate: 55 }}
              </h2>
            }
          </div>
          <div class="body">
            @if (
              messageRecipient.message_set.messages[0].images[0] ||
              messageRecipient.message_set.messages[0].videos[0]
              ) {
              <p
                >
                {{ messageRecipient.message_set.messages[0].body | truncate: 180 }}
              </p>
            }
            @if (
              !messageRecipient.message_set.messages[0].images[0] &&
              !messageRecipient.message_set.messages[0].videos[0]
              ) {
              <p
                >
                {{ messageRecipient.message_set.messages[0].body | truncate: 235 }}
              </p>
            }
          </div>
        </div>
      </div>
      @if (messageRecipient.recipient) {
        <div id="footer">
          @if (messageRecipient.responses.length > 0) {
            <h3>
              {{ "HISTORY_RESPONSE" | translate }}
              <span class="response-label">{{
                messageRecipient.responses[0].choice.choice_text | uppercase
              }}</span>
              {{ "HISTORY_AT" | translate }}
              {{ messageRecipient.status_changed | date: "medium" }}
            </h3>
          }
          @if (messageRecipient.responses.length === 0) {
            <h3>
              {{ "HISTORY_NO_RESPONSE" | translate }}
            </h3>
          }
        </div>
      }
    </div>
  }
}
